<template>
    <div class="field">
        <label v-if="label" :for="id" v-html="label"></label>
        <p class="control">
            <textarea v-if="type === 'textarea'"
                      ref="input"
                      :id="id"
                      :name="name"
                      v-model="tempValue"
                      :placeholder="placeholder"
                      :required="required"
                      @input="handleInput"
                      @keydown="handleKeyDown"
                      @blur="handleBlur"
                      @focus="handleFocus"
                      :class="{'textarea': true, 'is-danger': fieldErrors}"></textarea>

            <input v-if="type !== 'textarea'"
                   ref="input"
                   :id="id"
                   :name="name"
                   :type="type"
                   :value="tempValue"
                   :placeholder="placeholder"
                   :required="required"
                   :disabled="disabled"
                   @input="handleInput"
                   @keydown="handleKeyDown"
                   @blur="handleBlur"
                   @focus="handleFocus"
                   :class="{'input': true, 'is-danger': fieldErrors}">
        </p>

        <ul class="help is-danger form-errors" v-if="fieldErrors">
            <li v-for="error in fieldErrors">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
    import VuexTextMixin from "vuex-forms/lib/mixins/vuex-text"
    export default {
        name: 'TextInput',
        mixins: [VuexTextMixin()]
    }
</script>


// WEBPACK FOOTER //
// TextInput.vue?44917a28